import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || "https://vtogrqepcrfbdianhvuv.supabase.co"

const supabaseKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0b2dycWVwY3JmYmRpYW5odnV2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwNDE5NzUsImV4cCI6MjA2NjYxNzk3NX0.wP4WBdSrMBkd7QGxqrp69l30hWZM_W23QJGzYCVYaUs"

if (!supabaseUrl || !supabaseKey) {
  console.error('Supabase configuration is missing. Please check your environment variables.')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  global: {
    headers: (() => {
      const headers: Record<string, string> = {
        'X-Client-Info': 'warrior-hub@1.0.0'
      }

      if (typeof window !== 'undefined') {
        const impersonationContext = (window as any).__IMPERSONATION_CONTEXT__

        if (impersonationContext?.active && impersonationContext.dojoId) {
          headers['x-impersonation-active'] = 'true'
          headers['x-impersonation-dojo-id'] = impersonationContext.dojoId
        }
      }

      return headers
    })()
  }
})
